import ajax from "./ajax";

/**
 * 包含应用中所有请求接口函数的模块
 */

// const baseUrl = 'http://121.43.155.171/api/';
// const baseUrl = 'http://192.168.16.68:8000/api/';
// const baseUrl = 'http://192.168.16.121:9000/api/';
const baseUrl = '/api/';
/*const baseUrl = 'http://127.0.0.1/api/';*/
/*const baseUrl = 'http://101.132.242.111/api/';*/
//登录
/*
export function reqLogin(username,password) {
    return ajax('/login',{username,password},'POST');
}*/
export const reqLogin = (loginData) => ajax(baseUrl + 'login', loginData, 'POST');
//获取技能训练列表
export const reqSkill = (cid, page, size) => ajax(baseUrl+'skill',{cid, page, size},'GET');
//技能训练详情
export const reqSkillDetail = (detailId) => ajax(baseUrl+'skill/'+detailId,{},'GET');
//删除技能试题示例
export const reqDeleteSkill = (ids) => ajax(baseUrl+'skill/'+ids,{},'DELETE');
//获取案例学习列表
export const reqCase = (cid, page, size) => ajax(baseUrl+'case',{cid, page, size},'GET');
//管理员获取案例学习
export const reqadminCase = (cid, page, size) => ajax(baseUrl+'case?isAsc=false',{cid, page, size},'GET');
//案例学习详情
export const reqCaseDetail = (detailId) => ajax(baseUrl+'case/'+detailId,{},'GET');
// 获取案例部分信息及其题库列表
export const reqAllCaseList = (id) => ajax(baseUrl+'case/'+id,{},'GET');
//添加学生
export const reqAddStudent = (student) => ajax(baseUrl+'users/student',student,'POST');
//修改学生
export const reqEditStudent = (id,student) => ajax(baseUrl+'users/student/'+id,student,'PUT');
//获取学生列表
export const reqStudentList = (data) => ajax(baseUrl+'users/student',data,'GET');
//导入学生
export const reqUploadStudent = (data) => ajax(baseUrl+'users/student/import',data,'POST');
//获取教师列表
export const reqTeacherList = (data) => ajax(baseUrl+'users/teacher',data,'GET');
//添加教师
export const reqAddTeacher = (did,teacher) => ajax(baseUrl+'users/'+did+'/teacher',teacher,'POST');
//修改教师
export const reqEditTeacher = (did,id,teacher) => ajax(baseUrl+'users/'+did+'/teacher/'+id,teacher,'PUT');
//修改教师密码
export const reqPwdTeacher = (data) => ajax(baseUrl+'users/changePwd',data,'PUT')

//修改admin
export const reqEditadmin = (admin,code) => ajax(baseUrl+'users/admin/info?code='+code,admin,'PUT')
//修改admin密码
export const reqEditAdminPwd = (data) => ajax(baseUrl+'users/admin/pwd',data,'PUT') 
// export const reqEditAdminPwd = (pwd,code) => ajax(baseUrl+'users/admin/pwd?code='+code,pwd,'PUT') 
//获取code
export const reqGetCode = () => ajax(baseUrl+'help/superToken','GET')

//获取学生成绩列表
export const reqScoreList = (data) => ajax(baseUrl+'test',data,'GET');
//删除学生考卷
export const reqDeleteScore = (id,paperNo) => ajax(baseUrl+'test/'+id+'/'+paperNo,{},'DELETE');
//获取当前用户
export const reqCurrent = () => ajax(baseUrl+'users/current',{},'GET');
// export const reqCurrent1 = (data) => ajax(baseUrl+'users/current',data,'GET');
//获取回复量
export const reqCount = (data) => ajax(baseUrl +'users/topicMessageCount' ,data,'GET')
//获取班级列表
export const reqClassList = (data) => ajax(baseUrl+'classrooms',data,'GET');
//添加年级
export const reqAddGrade = (data) => ajax(baseUrl+'grade',data,'POST');
//编辑年级
export const reqEditGrade = (id,data) => ajax(baseUrl+'grade/'+id,data,'PUT');
//获取年级列表
export const reqGradeList = (data) => ajax(baseUrl+'grade',data,'GET');
//添加班级
export const reqAddClass = (data) => ajax(baseUrl+'classrooms',data,'POST');
//编辑班级
export const reqEditClass = (cid,data) => ajax(baseUrl+'classrooms/'+cid,data,'PUT');
//添加院系
export const reqAddDepartment = (data) => ajax(baseUrl+'departments',data,'POST');
//编辑院系
export const reqEditDepartment = (id,data) => ajax(baseUrl+'departments/'+id,data,'PUT');
//获取院系列表
export const reqDepartmentList = (data) => ajax(baseUrl+'departments',data,'GET');
//删除用户
export const reqDeleteStudent = (id) => ajax(baseUrl+'users/'+id,{},'DELETE');
//禁用用户
export const reqDisableStudent = (ids) => ajax(baseUrl+'users/'+ids+"/disable",{},'DELETE');
//启用用户
export const reqEnableStudent = (ids) => ajax(baseUrl+'users/'+ids+"/enable",{},'PUT');
//退出登录
export const reqLogOut = () => ajax(baseUrl+'logout',{},'GET');
//图片上传
export const reqUpload = (data) => ajax(baseUrl+'upload',data,'POST');
//试卷
export const reqExam = (data) => ajax(baseUrl+'mock-test/skills/generate',data,'GET');
//话题列表
export const reqQuestion = (data) => ajax(baseUrl+'topic',data,'GET');
//我的话题列表
export const reqMyQuestion = (data) => ajax(baseUrl+'topic/mine',data,'GET');
//话题回复列表
export const reqReplyList = (tid,data) => ajax(baseUrl+'topic/'+tid+'/message',data,'GET');
//分类列表
export const reqCategory = (type) => ajax(baseUrl+'category/'+type,{},'GET');
//添加技能训练
export const reqAddSkill = (cid,data) => ajax(baseUrl+'skill/'+cid+'/sample',data,'POST');
//修改技能训练
export const reqEditSkill = (cid,data) => ajax(baseUrl+'skill/'+cid+'/sample',data,'PUT');
//添加案例学习
export const reqAddCase = (cid,data) => ajax(baseUrl+'case/'+cid+'/sample',data,'POST');
//修改案例学习
export const reqEditCase = (cid,data) => ajax(baseUrl+'case/'+cid+'/sample',data,'PUT');
//添加病例问题
export const reqAddQue = (qid,data) => ajax(baseUrl+'case/'+qid+'/question',data,'POST');
//修改病例问题
export const reqEditQue = (qid,data) => ajax(baseUrl+'case/'+qid+'/question',data,'PUT');
//发表话题
export const reqAddTopic = (data) => ajax(baseUrl+'topic',data,'POST');
//回复话题
export const reqReply = (tid,data) => ajax(baseUrl+'topic/'+tid+'/message',data,'POST');
//回复话题的回复
export const reqReplyTwo = (tid,mid,data) => ajax(baseUrl+'topic/'+tid+'/message/'+mid,data,'POST');
//删除话题回复
export const reqDelReply = (tid,mid,data) => ajax(baseUrl+'topic/'+tid+'/message/'+mid+'?message='+data,{},'DELETE');
//删除话题
export const reqDelTopic = (tid) => ajax(baseUrl+'topic/'+tid,{},'DELETE');
//获取综合考核列表
export const reqCheckList = (data) => ajax(baseUrl+'skill/list',data,'GET');
export const reqCheckListA = (data) => ajax(baseUrl+'skill/list/'+'?type=A&containsOptions=true',data,'GET');
export const reqCheckListB = (data) => ajax(baseUrl+'skill/list/'+'?type=B&containsOptions=true',data,'GET');
export const reqCheckListX = (data) => ajax(baseUrl+'skill/list/'+'?type=X&containsOptions=true',data,'GET');
//根据id获取选择题详情
export const reqChoiceDetails = (id) => ajax(baseUrl+'skill/'+id,'GET')

//获取病例考核列表
export const reqIllCaseList = (data) => ajax(baseUrl+'case/questions',data,'GET');
//添加综合考核
export const reqAddCheck = (cid,data) => ajax(baseUrl+'skill/'+cid,data,'POST');
//修改综合考核
export const reqEditCheck = (cid,data) => ajax(baseUrl+'skill/'+cid,data,'PUT');
//删除综合考核试题
export const reqDeleteCheck = (ids) => ajax(baseUrl+'skill/'+ids,{},'DELETE');
//删除综合考核问题
export const reqDeleteCheckQ = (id,qid) => ajax(baseUrl+'skill/'+id+'/question/'+qid,{},'DELETE');
//添加病例题目
export const reqAddIllCase = (data) => ajax(baseUrl+'case/0',data,'POST');
//修改病例题目
export const reqEditIllCase = (data) => ajax(baseUrl+'case/0',data,'PUT');
//删除病例题目
export const reqDeleteIllCase = (id) => ajax(baseUrl+'case/'+id,{},'DELETE');
//新增病例问题
export const reqAddIllQuestion = (id,data) => ajax(baseUrl+'case/'+id+'/question',data,'POST');
//修改病例问题
export const reqEditIllQuestion = (id,data) => ajax(baseUrl+'case/'+id+'/question',data,'PUT');
//删除病例问题
export const reqDeleteIllQuestion = (id,qid) => ajax(baseUrl+'case/'+id+'/question/'+qid,{},'DELETE');
//获取试卷列表
export const reqPaperList = (data) => ajax(baseUrl+'formal-test',data,'GET');
//替换指定试卷的指定案例及题目
export const reqCaseList = (paperId ,caseId  ,qIds ) => ajax(baseUrl+'formal-test/'+paperId+'/'+caseId +'/'+ qIds,{},'PUT');

//新增试卷
export const reqAddPaper = (data) => ajax(baseUrl+'formal-test/generate',data,'POST');
//发布试卷
export const reqPubPaper = (id) => ajax(baseUrl+'formal-test/pub/'+id,{},'PUT');
//查看试卷
export const reqPaper = (id) => ajax(baseUrl+'formal-test/'+id,{},'GET');
//试卷考试安排
export const reqPaperAssign = (id,cid,data) => ajax(baseUrl+'formal-test/assign/'+id+'/'+cid,data,'PUT');
//考试场次
export const reqAssign = (id,data) => ajax(baseUrl+'formal-test/'+id+'/assigned',data,'GET');
//班级考试场次
export const reqAssignClass = (id,data) => ajax(baseUrl+'formal-test/assigned/'+id,data,'GET');
//题型统计
export const reqTypeNum = () => ajax(baseUrl+'formal-test/statistic',{},'GET');
//获取导入模板
export const reqTemplate = () => ajax(baseUrl+'users/student/template',{},'GET');
//添加专业
export const reqAddSpeciality = (data) => ajax(baseUrl+'specialty',data,'POST');
//编辑专业
export const reqEditSpeciality = (id,data) => ajax(baseUrl+'specialty/'+id,data,'PUT');
//获取专业列表
export const reqSpecialtyList = (data) => ajax(baseUrl+'specialty',data,'GET');
//当前用户试卷列表
export const reqUserPaper = (type) => ajax(baseUrl+'test/'+type,{},'GET');
//当前用户试卷
export const reqMyPaper = (pNo) => ajax(baseUrl+'test/my/'+pNo,{},'GET');
//查看学生考卷
export const reqStudentPaper = (uid,pNo) => ajax(baseUrl+'test/'+uid+'/'+pNo,{},'GET');
//学生考卷批量存档
export const reqDownloadPapers = (data) => ajax(baseUrl+'test/download',data,'POST');
//获取模拟试卷
export const reqMockPaper = () => ajax(baseUrl+'mock-test/generate',{},'POST');
//完成答卷
export const reqAnswerPaper = (pNo,data) => ajax(baseUrl+'test/'+pNo+'/answer',data,'POST');
//获取随机试题
export const reqRandomQue = (data) => ajax(baseUrl+'skill/questions/random',data,'GET');
//替换试题
export const reqChangeQue = (id,oldRefId,newRefId) => ajax(baseUrl+'formal-test/'+id+'/questions/skill/'+oldRefId+'/'+newRefId,{},'PUT');
//重新抽题
export const reqPickQue = (id,type) => ajax(baseUrl+'formal-test/'+id+'/questions/'+type,{},'PUT');
//我的成绩报告
export const reqMyRank = (type) => ajax(baseUrl+'report/my',{type},'GET');
//我的成绩列表
export const reqMyList = (type,size) => ajax(baseUrl+'report/my/history',{type,size},'GET');
//试卷报告
export const reqPaperReport = (data) => ajax(baseUrl+'report/testPaper',data,'GET');
//更新头像
export const reqAvatar = (data) => ajax(baseUrl+'users/avatar',data,'PUT');
//获取未读消息
export const reqMsgList = (data) => ajax(baseUrl+'message/my',data,'GET');
//设置未读消息为已读
export const reqReadMsg = (ids) => ajax(baseUrl+'message/'+ids,{},'DELETE');
//清空未读消息
export const reqDeleteMsg = () => ajax(baseUrl+'message/my',{},'DELETE');
//撤销班级考试安排
export const reqDeleteClassAssign = (id,cid) => ajax(baseUrl+'formal-test/assign/'+id+'/'+cid,{},'DELETE');
//删除试卷
export const reqDeletePaper = (ids) => ajax(baseUrl+'formal-test/'+ids,{},'DELETE');
//学生信息验证
export const reqVerifyStudent = (data) => ajax(baseUrl+'help/reset_pwd/student/identity/information',data,'POST');
//教师信息验证
export const reqVerifyTeacher = (data) => ajax(baseUrl+'help/reset_pwd/teacher/identity/information',data,'POST');
//重置密码
export const reqDoPassword = (data) => ajax(baseUrl+'help/reset_pwd/do',data,'POST');
//邮箱确认码
export const reqEmailCode = (data) => ajax(baseUrl+'help/reset_pwd/identity/email/verifycode',data,'POST');
//邮箱信息验证
export const reqVerifyEmail = (data) => ajax(baseUrl+'help/reset_pwd/identity/email',data,'POST');
//获取登录次数
export const reqLoginNum = () => ajax(baseUrl+'metrics/login',{},'GET');

//复制功能
export const reqCopy = (paperId) => ajax(baseUrl+'formal-test/copyPaper/'+paperId, {}, 'PUT');
// 修改试卷名称
export const reqModification = (paperId,name) => ajax(baseUrl+'test/'+paperId+'?name='+name,{},'PUT');


//添加综合考核
// export const reqAddCheck = (cid,data) => ajax(baseUrl+'skill/'+cid,data,'POST');
//修改综合考核
// export const reqEditCheck = (cid,data) => ajax(baseUrl+'skill/'+cid,data,'PUT');

//修改并添加综合考核
export const reqAddEnit = (paperId,old,cid,data) => ajax(baseUrl+'formal-test/'+paperId+'/coverQuestion/'+old+'/'+cid,data,'POST')

//获取是否发布试卷http://192.168.16.68:9000/api/formal-test/useStatus/51
export const reqPublishexam = (id) => ajax(baseUrl+'formal-test/useStatus/'+id,{},'GET');
// 学生重置密码
// export const resetStudentPwd = (id,data) => ajax(baseUrl+'users/resetPwd/student/'+id,data,'POST');
export const resetStudentPwd = (id,pwd) => ajax(baseUrl+'users/resetPwd/student/'+id+'?pwd='+pwd,{},'PUT');
// 老师重置密码
export const resetTeacherPwd = (id,pwd) => ajax(baseUrl+'users/resetPwd/teacher/'+id+'?pwd='+pwd,{},'PUT');
